import { apiRequest } from "./api";

/**
 * Fetch paginated list of review tasks.
 * @param {Object} [params]
 * @param {string} [params.status] - e.g. "needs_review"
 * @param {number} [params.page=1]
 * @param {number} [params.limit=100]
 * @returns {Promise<any>} resData.data  { items, pagination }
 */
export async function fetchReviews({ status, page = 1, limit = 100 } = {}) {
  const query = new URLSearchParams({ page, limit });
  if (status) query.set("status", status);
  const result = await apiRequest(`/admin/reviews?${query.toString()}`);
  return result.data;
}

/**
 * Fetch the full detail of a single review task.
 * Includes: submission metadata, submitted files (with file_id, file_type,
 * file_name, mime_type), and OCR-extracted ingredients / nutrition_facts.
 *
 * @param {string} reviewId
 * @returns {Promise<ReviewDetail>}
 */
export async function fetchReviewDetail(reviewId) {
  const result = await apiRequest(`/admin/reviews/${reviewId}`);
  return result.data;
}

/**
 * Submit a decision on a review task.
 * @param {string} reviewId
 * @param {Object} payload
 * @param {"approved"|"rejected"|"recapture"} payload.decision
 * @param {string|null} [payload.review_notes] - Required (>=20 chars) for rejected/recapture
 * @param {string|null} [payload.product_name]
 * @param {string|null} [payload.brand_name]
 * @param {string|null} [payload.category]
 * @param {string|null} [payload.existing_product_id]
 * @returns {Promise<any>} resData
 */
export async function submitReviewDecision(reviewId, payload) {
  const result = await apiRequest(`/admin/reviews/${reviewId}/decision`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return result;
}
